import type { ToolCallState, ToolRendererProps } from '@chatsdet/ui';
import type { FC } from 'react';
import { ExecuteSqlRenderer } from './ExecuteSqlRenderer';
import { PresentResultsRenderer } from './PresentResultsRenderer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const userEventsToolRenderers: Record<string, FC<ToolRendererProps<any, any>>> = {
  execute_sql: ExecuteSqlRenderer,
  present_results: PresentResultsRenderer,
};

export function mapToolState(aiSdkState: string): ToolCallState {
  switch (aiSdkState) {
    case 'input-streaming':
      return 'streaming';
    case 'input-available':
      return 'pending';
    case 'output-available':
      return 'success';
    case 'output-error':
      return 'error';
    default:
      return 'pending';
  }
}

const toolDisplayNames: Record<string, string> = {
  execute_sql: 'Running SQL',
  present_results: 'Presenting results',
};

export function getToolDisplayName(toolName: string): string {
  return toolDisplayNames[toolName] ?? toolName.replace(/_/g, ' ');
}
